import { toast } from "react-hot-toast";
import { apiClient } from "../../constants.ts";
import { Button, Collapsible, PageSpinner } from "./components.tsx";
import { useAuth, useQuery } from "./db.ts";

export const GmailConfig = ({ id }: { id: string }) => {
  const token = useAuth().user?.refresh_token;
  const { data, error, isLoading } = useQuery({
    bots: { $: { where: { id } } },
  });
  if (isLoading) return <PageSpinner />;
  if (error) return <div>Error: {error.message}</div>;
  const { bots } = data;
  const [bot] = bots;
  if (!bot) return <div>No bot found</div>;
  const isConfigured = !!bot.gmailTokenEnvName;

  return (
    <Collapsible title="Gmail">
      <div className="flex flex-col gap-4">
        <div className="text-sm text-text-secondary-light dark:text-text-secondary">
          {isConfigured
            ? "Gmail is connected. Your bot will use Gmail to send and receive emails."
            : "Connect a Gmail account to use it as an email channel for your bot."}
        </div>
        {isConfigured
          ? (
            <Button
              onClick={() => {
                if (!token) return;
                toast.promise(
                  apiClient({
                    token,
                    endpoint: "disconnect-gmail",
                    payload: { botId: bot.id },
                  }).then((res) => {
                    if (!res.success) {
                      throw new Error(res.error ?? "Unknown error");
                    }
                  }),
                  {
                    loading: "Disconnecting Gmail...",
                    success: "Gmail disconnected.",
                    error: (err) =>
                      `Failed to disconnect Gmail: ${err.message}`,
                  },
                );
              }}
              className="w-full md:w-auto"
            >
              Disconnect Gmail
            </Button>
          )
          : (
            <Button
              onClick={() => {
                if (!token) return;
                toast.promise(
                  apiClient({
                    token,
                    endpoint: "connect-gmail",
                    payload: { botId: bot.id },
                  }).then((res) => {
                    if (!res.success) throw new Error(res.error);
                    globalThis.location.href = res.authUrl;
                  }),
                  {
                    loading: "Starting Gmail authorization...",
                    success: "Redirecting to Google...",
                    error: (err) => `Failed to connect Gmail: ${err.message}`,
                  },
                );
              }}
              className="w-full md:w-auto"
            >
              Connect Gmail
            </Button>
          )}
      </div>
    </Collapsible>
  );
};
